import { useEffect, useRef } from 'react';

export default function NewsletterSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el) => el.classList.add('animate-in'));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20elegant%20home%20entrance%20with%20a%20stylish%20house%20number%20plate%20and%20door%20plate%2C%20warm%20golden%20hour%20lighting%2C%20beautiful%20garden%20path%20leading%20to%20the%20door%2C%20professional%20architectural%20photography%20with%20soft%20natural%20lighting%20and%20clean%20composition%2C%20inviting%20home%20exterior&width=1600&height=900&seq=newsletter-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out max-w-2xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-6 bg-amber-500/20 rounded-full">
            <i className="ri-mail-line text-amber-400 text-xl" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
            Prijavi se na bilten
          </h2>
          <p className="text-base text-white/85 mb-8 leading-relaxed">
            Prvi saznajte za nove proizvode i ekskluzivne ponude. Preko 10.000 korisnika već prima vesti od nas.
          </p>

          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Unesi email adresu"
              className="flex-1 px-4 py-3 bg-white border border-background-200 rounded-lg text-sm font-label text-foreground-950 placeholder:text-foreground-600 focus:outline-none focus:border-amber-500 transition-colors"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-amber-600 text-white font-label text-sm font-medium rounded-lg hover:bg-amber-700 transition-colors whitespace-nowrap"
            >
              Prijavi se
            </button>
          </form>
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}